var _style, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDna = function SvgDna(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 64,
    height: 64
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Dna_svg__st0{fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8.6c12.9 0 23.4 10.5 23.4 23.4S44.9 55.4 32 55.4 8.6 44.9 8.6 32 19.1 8.6 32 8.6M32 7C18.2 7 7 18.2 7 32s11.2 25 25 25 25-11.2 25-25S45.8 7 32 7",
    className: "Dna_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 37c1.9-2.1 1.4-4.8.5-7.5 2.7.8 5.5 1.1 7.4-1l-1.7-1.6c-.4.4-.8.6-1.3.8l-6.7-6.2c.1-.5.3-.9.7-1.3l-1.7-1.6c-2 2.1-1.4 4.8-.5 7.5-2.7-.8-5.5-1.1-7.4 1s-1.4 4.8-.5 7.5c-2.7-.8-5.5-1.1-7.4 1l1.7 1.6c.4-.4.8-.6 1.3-.8l6.7 6.2c-.1.5-.3.9-.7 1.3l1.7 1.6c2-2.1 1.4-4.8.5-7.5 2.7.7 5.5 1 7.4-1m-1.6-13.5 4.5 4.2c-1.1-.1-2.2-.5-3.4-.9-.5-1.2-.9-2.3-1.1-3.3m-.6 5.1c.5 1.4 1 2.7 1.2 3.9l-5.2-4.9c1.2.2 2.6.6 4 1m.5 6.8q-.45.45-.9.6l-6.9-6.5c.1-.3.3-.7.6-.9q.45-.45.9-.6l6.9 6.4c-.1.4-.3.7-.6 1m-7.3 5.1-4.5-4.2c1.1.1 2.2.5 3.4.9.5 1.2.9 2.3 1.1 3.3m.6-5.1c-.5-1.4-1-2.7-1.2-3.9l5.2 4.8c-1.2-.1-2.6-.5-4-.9",
    className: "Dna_svg__st0"
  })));
};
export default SvgDna;